import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  Professional,
} from '@adeo/ngx-kozikaza-api';
import {
  ProfessionalServicePriceType,
  ProfessionalServiceRessource,
  ProfessionalServiceService,
} from '@adeo/ngx-kozikaza-api/pro/service';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { UserStoreService } from '../../../../../../shared/services/state-management/user-store.service';
import { KzIconsRegistryService } from '../../../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsLaptop } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-laptop.icon';
import { kzIconsKaza } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-kaza.icon';
import { Router } from "@angular/router";
import { LocalizeRouterService } from "@gilsdav/ngx-translate-router";

@Component({
  selector: 'app-pro-listing-item',
  templateUrl: './pro-listing-item.component.html',
  styleUrls: ['./pro-listing-item.component.scss'],
})
export class ProListingItemComponent implements OnInit {
  @Input() pro: Professional;
  @Input() displayBestPrice = false;
  @Input() showDistance = false;
  @Input() preloadImages = false;
  @Input() fetchPriority = false;
  @Input() miniCover = false;

  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  public priceType = ProfessionalServicePriceType;
  public serviceWithBestPriceObs: Observable<ProfessionalServiceRessource>;

  public limitStyles = 2;
  position: string;

  constructor(
    private professionalServiceService: ProfessionalServiceService,
    public userStoreService: UserStoreService,
    private kzIconsRegistryService: KzIconsRegistryService,
    private readonly router: Router,
    private readonly localizeRouterService: LocalizeRouterService,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsLaptop, kzIconsKaza]);
  }

  ngOnInit(): void {
    if (!!this.pro.serviceBestWithPrice) {
      this.serviceWithBestPriceObs =
        this.professionalServiceService.getProfessionalService(this.pro.serviceBestWithPrice).pipe(share());
    }
  }

  redirectToProChat(reach5Id: string) {
    this.router.navigate(this.localizeRouterService.translateRoute(['chat', 'new',  reach5Id])as string[], {replaceUrl: true}).then();
  }
}
